import { useIntl } from 'react-intl';
import { OpportunityStatus } from '../../gql/graphql';

export const useOpportunityStatusOptions = (): {
	statusOptions: {
		value: OpportunityStatus;
		text: string;
		color: string;
	}[];
} => {
	const intl = useIntl();

	return {
		statusOptions: [
			{
				value: 'new',
				text: intl.formatMessage({ id: 'opportunity.status.new' }),
				color: '#1890FF',
			},
			{
				value: 'open',
				text: intl.formatMessage({ id: 'opportunity.status.open' }),
				color: '#FAAD14',
			},
			{
				value: 'postponed',
				text: intl.formatMessage({ id: 'opportunity.status.postponed' }),
				color: '#8c2020',
			},
			{
				value: 'resolved',
				text: intl.formatMessage({ id: 'opportunity.status.resolved' }),
				color: '#52C41A',
			},
			{
				value: 'archived',
				text: intl.formatMessage({ id: 'opportunity.status.archived' }),
				color: '#8C8C8C',
			},
		],
	};
};
